export function mergeArrays(arr1: any[], arr2: any[]) {
  return arr1.map((item, index) =>
    arr2[index] !== undefined ? arr2[index] : item
  );
}
